<template>
  <div>
    <div v-if="isUpload">
      <div style="text-align: right">
        <el-button
size="mini"
type="primary"
@click="handleAppCreate"
          v-permit="'User.Market.Application.Version.Create'">
          上传新版本
        </el-button>
      </div>
      <div class="table-container">
        <el-alert
v-if="appDetail.templateType == 'rainbond'"
style="margin-bottom: 16px"
          title="应用独立交付版本需要由Rainbond PaaS平台进行发布"
type="success"></el-alert>
        <public-table
v-loading="Loading"
:column="column"
:tableData="versions"
          :addPerm="'User.Market.Application.Version.Create'">
          <template v-slot:appVersion="{ row }">
          {{
            row.appVersion
          }} {{
          row.appVersionAlias ? `(${row.appVersionAlias})` : ''
          }}
          </template>
          <template v-slot:createTime="{ row }">{{
            row.createTime ? timetrans(row.createTime) : '-'
          }}</template>
          <template v-slot:arch="{ row }">{{
            row.arch != "" ? row.arch : '-'
          }}</template>
          <template v-slot:desc="{ row }">{{
            row.desc != "" ? row.desc : '-'
          }}</template>
          <template v-slot:updateTime="{ row }">{{
            row.updateTime ? timetrans(row.updateTime) : '-'
          }}</template>
          <template v-slot:operation="{ row }">
            <el-button
size="mini"
type="text"
v-permit="'User.Market.Application.Version.Update'"
              @click="handleEditVersion(row)">
              编辑
            </el-button>
            <el-button
size="mini"
type="text"
v-if="row.deliveryMode == 'saas'"
              v-permit="'User.Market.Application.Version.Template.Update'"
@click="handleEditVersionTemplate(row)">
              更新模版
            </el-button>
            <el-button size="mini" type="text" v-permit="'User.Market.Application.Version.Delete'" @click="deleteVersion(row)">
              删除
            </el-button>
            <el-button
size="mini"
type="text"
@click="handleOfflinePackage(row)"
              v-permit="'User.Market.Application.OfflinePackage.List'"
v-if="row.templateType == 'RAM'">
              离线包
            </el-button>
          </template>
        </public-table>
        <!-- <EditAppVersion
        :marketID="marketID"
        :version="editVersion"
        :appID="appID"
        :dialogVisible="showEditVersion"
        :onSuccess="editVersionSuccess"
        :onClose="() => (showEditVersion = false)"
      ></EditAppVersion>
      <EditHelmVersion
        :marketID="marketID"
        :version="editVersion"
        :appID="appID"
        :dialogVisible="showHelmVersion"
        :onSuccess="editHelmVersionSuccess"
        :onClose="() => (showHelmVersion = false)"
      ></EditHelmVersion>
      <AddAppSaaSVersion
        :marketID="marketID"
        :appID="appID"
        :dialogVisible="showAddSaaSVersion"
        :onSuccess="addVersionSuccess"
        :onClose="() => (showAddSaaSVersion = false)"
      >
      </AddAppSaaSVersion>
      <EditAppVersionTemplate
        :marketID="marketID"
        :appID="appID"
        v-if="editTemplateVersion.appVersion"
        :version="editTemplateVersion.appVersion"
        :dialogVisible="editTemplateVersionShow"
        :onSuccess="updateVersionTemplateSuccess"
        :onClose="() => (editTemplateVersionShow = false)"
      >
      </EditAppVersionTemplate> -->
        <OfflinePackageTemplate
:marketID="marketID"
:appID="appID"
          v-if="offlinePackageVisible && offlinePackageInfo.appVersion"
:version="offlinePackageInfo.appVersion"
          :dialogVisible="offlinePackageVisible"
:onSuccess="offlinePackageTemplateSuccess"
          :onClose="() => (offlinePackageVisible = false)">
        </OfflinePackageTemplate>
        <!-- <AppHelmCreate
        :marketID="marketID"
        :appID="appID"
        :appType="appDetail.templateType"
        :dialogVisible="showCreateAppHelm"
        :onSuccess="handleAppHelmCreateSuccess"
        :onClose="() => (showCreateAppHelm = false)"
      >
      </AppHelmCreate> -->
        <!-- <AppSoftwareCreate
        :marketID="marketID"
        :appID="appID"
        :appType="appDetail.templateType"
        :dialogVisible="showCreateAppSoftware"
        :onSuccess="handleAppSoftwareCreateSuccess"
        :onClose="() => (showCreateAppSoftware = false)"
      >
      </AppSoftwareCreate> -->
      </div>
    </div>
    <AppUploadEntrance
v-else
:marketID="marketID"
:appID="appID"
:onSuccess="handleAppHelmCreateSuccess"
      :editInfo="editVersion"
:type="type"
:handletAbleShow="handletAbleShow"/>
  </div>
</template>
<script>
import { timetrans } from '@/utils/validate';
import { fetchAppVersions, deleteAppVersion, uploadBinaryFileInfo } from '@/api/app';
import EditAppVersion from './editAppVersion';
import EditHelmVersion from './editHelmVersion';
import AddAppSaaSVersion from './addAppSaaSVersion';
import EditAppVersionTemplate from './editAppSaaSVersionTemplate';
import AppUploadEntrance from './appUploadEntrance';
import OfflinePackageTemplate from './offlinePackageTemplate';
import AppHelmCreate from './appHelmCreate';
import AppSoftwareCreate from './appSoftwareCreate';
export default {
  name: 'AppVersionList',
  props: {
    appDetail: {
      type: Object
    },
    marketID: {
      type: String
    }
  },
  components: {
    EditAppVersion,
    EditHelmVersion,
    AddAppSaaSVersion,
    EditAppVersionTemplate,
    OfflinePackageTemplate,
    AppHelmCreate,
    AppSoftwareCreate,
    AppUploadEntrance
  },
  data() {
    return {
      type: '',
      isUpload: true,
      Loading: true,
      appID: this.$route.params.appID,
      timetrans: timetrans,
      versions: [],
      showEditVersion: false,
      editVersion: {},
      showAddSaaSVersion: false,
      editTemplateVersion: {},
      offlinePackageInfo: {},
      offlinePackageVisible: false,
      editTemplateVersionShow: false,
      showCreateAppHelm: false,
      showCreateAppSoftware: false,
      showHelmVersion: false,
      column: [
        {
          prop: 'appVersion',
          label: '版本号(版本别名)',
          width: '140px',
          scopeStatus: true
        },
        {
          prop: 'templateType',
          label: '包类型',
          width: '80px'
        },
        {
          prop: 'arch',
          label: '架构',
          width: '140px',
          scopeStatus: true
        },
        {
          prop: 'desc',
          label: '版本描述（更新日志）',
          scopeStatus: true
        },
        {
          prop: 'createTime',
          label: '创建时间',
          scopeStatus: true,
          width: '94px'
        },
        {
          prop: 'updateTime',
          label: '更新时间',
          scopeStatus: true,
          width: '94px'
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true,
          width: '140px'
        }
      ],
      columnHelm: [
        {
          prop: 'appVersion',
          label: '版本号',
          width: '140px'
        },
        {
          prop: 'appVersionAlias',
          label: '版本别名',
          width: '140px'
        },
        {
          prop: 'desc',
          label: '版本描述'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          scopeStatus: true,
          width: '94px'
        },
        {
          prop: 'updateTime',
          label: '更新时间',
          scopeStatus: true,
          width: '94px'
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true,
          width: '130px'
        }
      ],
      columnSoftware: [
        {
          prop: 'appVersion',
          label: '版本号',
          width: '140px'
        },
        {
          prop: 'appVersionAlias',
          label: '版本别名',
          width: '140px'
        },
        {
          prop: 'desc',
          label: '版本描述'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          scopeStatus: true,
          width: '94px'
        },
        {
          prop: 'updateTime',
          label: '更新时间',
          scopeStatus: true,
          width: '94px'
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true,
          width: '130px'
        }
      ]
    };
  },
  created() {
    this.fetchAppVersionList();
  },
  mounted() { },
  methods: {
    fetchAppVersionList() {
      fetchAppVersions({ marketID: this.marketID, appID: this.appID })
        .then((res) => {
          this.Loading = false;
          this.versions = res.versions;
        })
        .catch((err) => {
          this.Loading = false;
          if (err.code == 404) {
            this.$router.push({
              name: 'appManage'
            });
          }
        });
    },
    deleteVersion(row) {
      this.$confirm('是否要删除该应用版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onDeleteAppVersion(row);
      });
    },
    onDeleteAppVersion(row) {
      deleteAppVersion({
        marketID: this.marketID,
        appID: this.appID,
        version: row.appVersion
      })
        .then((res) => {
          this.Loading = false;
          this.fetchAppVersionList();
        })
        .catch((err) => {
          if (err.code == 10023) {
            this.$message.warning('当前版本包含套餐，不能删除');
          } else {
            this.$message.warning(err.msg);
          }
        });
    },
    // 编辑版本
    handleEditVersion(row) {
      this.editVersion = row;
      this.type = row.templateType
      this.isUpload = false;
      // this.showEditVersion = true;
    },
    editVersionSuccess() {
      this.showEditVersion = false;
      this.fetchAppVersionList();
    },
    addVersionSuccess() {
      this.showAddSaaSVersion = false;
      this.fetchAppVersionList();
    },
    handleEditVersionTemplate(row) {
      this.editTemplateVersion = row;
      this.editTemplateVersionShow = true;
    },
    handleOfflinePackage(row) {
      this.offlinePackageInfo = row;
      this.offlinePackageVisible = true;
    },
    updateVersionTemplateSuccess() {
      this.editTemplateVersionShow = false;
      this.editTemplateVersion = null;
    },
    offlinePackageTemplateSuccess() {
      this.offlinePackageVisible = false;
      this.offlinePackageInfo = null;
    },
    // helm
    handleAppCreate() {
      this.isUpload = false;
      this.editVersion = {};
      this.type = 'helm'
    },
    handletAbleShow() {
      this.isUpload = true;
      this.editVersion = {};
      this.type = ''
      this.fetchAppVersionList();
    },
    handleReuploadHelm(row) {
      this.editVersion = row;
      this.showHelmVersion = true;
    },
    editHelmVersionSuccess() {
      this.showHelmVersion = false;
      this.fetchAppVersionList();
    },
    handleAppHelmCreateSuccess() {
      this.fetchAppVersionList();
      this.handletAbleShow()
    },
    // 二进制
    handleAppSoftwareCreate() {
      this.showCreateAppSoftware = true;
    },
    handleAppSoftwareCreateSuccess(params) {
      uploadBinaryFileInfo(params)
        .then((res) => {
          this.versions = res.bean.versions;
          this.showCreateAppSoftware = false;
        })
        .catch((err) => {
          this.Loading = false;
          this.$message({
            message: '创建版本失败',
            type: 'error'
          });
        });
    }
  }
};
</script>






// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/appVersion.vue